export default "__VITE_ASSET__D957lS4M__"